export enum EmailSource {
    VirtualAssistant = 'virtualAssistant',
    Feedback = 'feedback',
    GlobalApi = 'globalApi',
}

export interface EmailDto {
    /**
     * Тема
     */
    title: string;
    /**
     * Сообщение
     */
    content: string;
    /**
     * ФИО/Наименование организации
     */
    name: string;
    /**
     * Номер телефона
     */
    phoneNumber: string;
    /**
     * Почта
     */
    email: string;
    /**
     * Источник
     */
    source: EmailSource;
}
